module.exports = __webpack_public_path__ + "img/Panax_ginseng.ee7685d1.jpg";